import { PageHeader } from "@/components/PageHeader";
import { ProgramsSection } from "@/components/home/ProgramsSection";
import { CTASection } from "@/components/CTASection";
import { BrandMarquee } from "@/components/BrandMarquee";
import { IMG } from "@/lib/content";
import { useSeo } from "@/lib/useSeo";

export default function Services() {
  useSeo({
    title: "Services | Sports Performance & Training for Baseball & Softball — DST New Braunfels",
    description: "Explore DST New Braunfels training programs: sports performance, baseball & softball instruction, private training, and group training in New Braunfels, TX.",
  });
  return (
    <>
      <PageHeader
        eyebrow="Programs & Services"
        title={<>Train With<br />Purpose.</>}
        subtitle="Led by our specialty — competitive group training — plus baseball & softball instruction, sports performance, and private one-on-ones."
        image={IMG.sprint}
      />
      <ProgramsSection full />
      <BrandMarquee theme="red" />
      <CTASection />
    </>
  );
}
